// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const ChartTooltipSingleIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon
      data-iconname="ChartTooltipSingleIcon"
      ref={forwardedRef}
      {...props}
    >
      <path d="M7 11a1 1 0 1 0 0-2 1 1 0 0 0 0 2" />
      <path d="M3 7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1zm1.5 5.5h11v-5h-11z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const ChartTooltipSingleIcon = /* @__PURE__ */ Object.assign(
  ChartTooltipSingleIconComponent,
  { displayName: 'ChartTooltipSingleIcon' },
);
